export const environment = {
  production: false,
  raygunApiKey: "yNmBwVohUFVzp5NfVzQOkQ",
  apiUrl: "https://lgtapi-dev.agilx.com/api/",
  filesUrl: "https://lgtapi-dev.agilx.com/api/",
  url: "https://lgt-dev.agilx.com/",
  urlClient: "https://lgt-dev.agilx.com/",
  googleMapsApiKey: "AIzaSyBqSQGcjeP3kqGyhT5LLqgDWnr2Xrz0LOU",
};
